import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as service from '../services';
import { useAderenciaBigNumbers } from './useAderenciaBigNumbers';
import { useAderenciaHistory } from './useAderenciaHistory';
import { useProductsByRange } from './useProductsByRange';
import { useAderenciaDetailing } from './useAderenciaDetailing';
import { useAderenciaPrecosStore } from '../AderenciaPrecos.store';
import { AderenciaStatusResponse } from '../types';

export const useAderenciaStatus = () => {
  const [aderenciaEntryStatus, setAderenciaEntryStatus] = useState<number | null>(null);
  const [aderenciaStatusData, setAderenciaStatusData] = useState<AderenciaStatusResponse>({} as AderenciaStatusResponse);
  const { aderenciaBodyRequest, aderenciaDetailsBodyRequest } = useAderenciaPrecosStore();
  const { handleGetAderenciaBigNumbers } = useAderenciaBigNumbers();
  const { handleGetAderenciaHistoryChart } = useAderenciaHistory();
  const { handleRequestProductByRange } = useProductsByRange();
  const { handleGetAderenciaDetails } = useAderenciaDetailing();

  const getStatus = async () => {
    const resp = await service.getAderenciaStatus();
    setAderenciaEntryStatus(resp?.status);
    setAderenciaStatusData(resp?.data);
    if (resp?.status === 200 && resp?.data) {
      try {
        const body = aderenciaBodyRequest;
        const detailsBody = { ...aderenciaDetailsBodyRequest, ...body };

        await handleGetAderenciaBigNumbers(body);
        await handleGetAderenciaHistoryChart(body);
        await handleRequestProductByRange(body);
        await handleGetAderenciaDetails(detailsBody);
      } catch (error) {
        console.error('Erro ao buscar dados da aderencia:', error);
      }
    }
    return resp;
  };

  useQuery({
    queryKey: ['get-aderencia-status'],
    queryFn: getStatus,
    retry: false,
  });

  return {
    aderenciaEntryStatus,
    aderenciaStatusData,
  };
};
